// import 'animate.css';
import React, { useEffect } from 'react';
import { Card, Row, Col, Container } from 'react-bootstrap';
import './AboutUs.css'; // Import your CSS file
import Aos from 'aos';
import './aos.css';



// const cardData = [
//   { title: 'ACADEMIC YEAR', text: 'The academic year runs from September to June.There are three (03) terms in the Primary Section and two(02) in the Secondary / A Level Section:' },
//   { title: 'PRIMARY', text: 'First Term: September – December Second Term: January – March Third Term: April – June' },
//   { title: 'Secondary', text: 'First Term: September – January Second Term: February – June' },
//   { title: 'ACADEMY TIMINGS', text: 'The Academy will be open from Monday to Thursday from 08h00 to 15h10 and on Friday from 08h00 till 12h30.Students must report to the Academy by 07h45. Timings for Playgroup and FS I are from 07h45 to 12h30 and from 07h45 until 14h00 for FS 2 and Year 1. The Academy gates will be closed at the ringing of the bell in the morning at 08h00. Late comers will not be allowed to enter the campus unless parents have informed the Academy. Any change in the Academy timing on account of examinations or other programmes in the Academy will be communicated to parents. Students picked up late after school-time may be required to pay additional fee on monthly basis.' },
// ];

const TwoByTwoCards = () => {
  useEffect(() => {
    Aos.init({});
  }, [])
  return (
    <Container className=" background" >
      {/* <Row>
        {cardData.map((card, index) => (
          <Col md={6} className="mb-4" key={index}>
            <div >
              <Card className="custom-card" >
                <Card.Body>
                  <div data-aos="fade-left">
                    <Card.Title>{card.title}</Card.Title>
                    <Card.Text>{card.text}</Card.Text>
                  </div>
                </Card.Body>
              </Card>
            </div>
          </Col>
        ))}
      </Row> */}


      <Row>
        <Col md={6} data-aos="fade-right" >
          <div className="overflow-box" style={{ marginLeft: '61px' }}>
            <p><strong>ACADEMIC YEAR</strong></p>
            <ul>
              <li> <p>The academic year runs from September to June.</p></li>
              <li><p>There are three (03) terms in the Primary Section and two(02) in the Secondary / A Level Section:</p></li>
            </ul>

          </div>
        </Col>
        <Col md={6} data-aos="fade-left" data-aos-delay="500">
          <div >
            <img
              src="/imageshome/academicyear.jpg"
              alt="Descriptive alt text"
              className="fit-image"
            />
          </div>
        </Col>

        <Col md={6} data-aos="fade-right" data-aos-delay="1000">
          <div >
            <img
              src="/imageshome/primary.jpeg"
              alt="Descriptive alt text"
              className="fit-image"
              style={{ marginLeft: '50px' }}
            />
          </div>
        </Col>
        <Col md={6} data-aos="fade-left" data-aos-delay="1500">
          <div className="overflow-box" style={{ marginRight: '30px', marginLeft: '-76px', marginRight: '94px' }}>
            <p><strong>PRIMARY </strong></p>
            <ul>
              <li><p>First Term: September – December</p></li>
              <li><p>Second Term: January – March</p></li>
              <li> <p>Third Term: April – June</p></li>
            </ul>
          </div>
        </Col>
        <Col md={6} data-aos="fade-right" >
          <div className="overflow-box" style={{ marginLeft: '63px', marginRight: '-12px' }} >
            <p><strong>Secondary</strong></p>
            <ul>
              <li><p>First Term: September – January</p></li>
              <li><p>Second Term: February – June</p></li>
            </ul>
            <p>&nbsp;</p>
          </div>
        </Col>
        <Col md={6} data-aos="fade-left"  data-aos-delay="1000">
          <div >
            <img
              src="/imageshome/secondary.jpeg"
              alt="Descriptive alt text"
              className="fit-image"
              style={{ marginLeft: '50px' }}
            />
          </div>
        </Col>
      </Row>
      <Row>
        <Col md={12} data-aos="fade-up">
          <div className="overflow-box" >
            <p><strong>ACADEMY TIMINGS</strong></p>
            <ol>
              <li>The Academy will be open from Monday to Thursday from 08h00 to 15h10 and on Friday from 08h00 till 12h30.Students must report to the Academy by 07h45.</li>
              <li>Timings for Playgroup and FS I are from 07h45 to 12h30 and from 07h45 until 14h00 for FS 2 and Year 1.</li>
              <li>The Academy gates will be closed at the ringing of the bell in the morning at 08h00. Late comers will not be allowed to enter the campus unless parents have informed the Academy.</li>
              <li>Any change in the Academy timing on account of examinations or other programmes in the Academy will be communicated to parents.</li>
              <li>Students picked up late after school-time may be required to pay additional fee on monthly basis.</li>
            </ol>
          </div>
        </Col>

      </Row>



    </Container>
  );
};

export default TwoByTwoCards;




// import 'animate.css';
// import React from 'react';
// import 'animate.css';

// const AnimatedComponent = () => {
// return (
// <div className="animate__animated animate__fadeInLeft">
// <h1>Hello, I bounce!</h1>
// </div>
// );
// };

// export default AnimatedComponent;
// ;
// import React from "react";
// import { Swiper, SwiperSlide } from "swiper/react";
// import "swiper/css";
// import "swiper/css/grid";

// import { Grid } from "swiper/modules";

// const items = [
//   "The academic year runs from September to June. There are three (03) terms in the Primary Section and two (02) in the Secondary / A Level Section:",
//   "First Term: September – December Second Term: January – March Third Term: April – June",
//   "First Term: September – Janrary Second Term: February – June Third Term: April – Junef",
//   "1. The Academy will be open from Monday to Thursday from 08h00 to 15h10 and on Friday from 08h00 till 12h30. Students must report to the Academy by 07h45. 2. Timings for Playgroup and FS I are from 07h45 to 12h30 and from 07h45 until 14h00 for FS 2 and Year 1. 3. The Academy gates will be closed at the ringing of the bell in the morning at 08h00. Late comers will not be allowed to enter the campus unless parents have informed the Academy. 4. Any change in the Academy timing on account of examinations or other programmes in the Academy will be communicated to parents. 5. Students picked up late after school-time may be required to pay additional fee on monthly basis.",
// ];

// const TwoColumnTwoRowCarousel = () => {
//   return (
//     <div style={{ width: "90%", margin: "0 auto" }}>
//       <Swiper
//         modules={[Grid]}
//         slidesPerView={4}
//         grid={{
//           rows: 4,
//           fill: "row", // row-wise filling
//         }}
//         spaceBetween={10}
//       >
//         {items.map((item, index) => (
//           <SwiperSlide key={index}>
//             <div
//               style={{
//                 padding: "20px",
//                 backgroundColor: "#FFBF00",
//                 borderRadius: "8px",
//                 textAlign: "center",
//               }}
//             >
//               {item}
//             </div>
//           </SwiperSlide>
//         ))}
//       </Swiper>
//     </div>
//   );
// };

// export default TwoColumnTwoRowCarousel;


// import Card from 'react-bootstrap/Card';
// import Row from 'react-bootstrap/Row';
// import Col from 'react-bootstrap/Col';
// import Container from 'react-bootstrap/Container';

// const cardContent = [
//   {
//     title: 'ACADEMIC YEAR',
//     text: `The academic year runs from September to June.
// There are three (03) terms in the Primary Section and two (02) in the Secondary / A Level Section:`,
//     image: '/imageshome/academicyear.jpg',
//     bgColor: '#FF00FF',
//     direction: 'image-left', // image on left, text on right
//   },
//   {
//     title: 'PRIMARY',
//     text: `First Term: September – December
// Second Term: January – March
// Third Term: April – June`,
//     image: '/imageshome/academicyear2.jpg',
//     bgColor: '#C0C0C0',
//     direction: 'text-left', // text on left, image on right
//   },
//     {
//     title: 'SECONDARY',
//     text: `First Term: September – Janrary
// Second Term: February – June
// Third Term: April – June`,
//     image: '/imageshome/academicyear2.jpg',
//     bgColor: '#FFBF00',
//     direction: 'text-left', // text on left, image on right
//   },
//     {
//     title: 'ACADAMY TIMING',
//     text: `1. The Academy will be open from Monday to Thursday from 08h00 to 15h10 and on Friday from 08h00 till 12h30. Students must report to the Academy by 07h45.
// 2. Timings for Playgroup and FS I are from 07h45 to 12h30 and from 07h45 until 14h00 for FS 2 and Year 1.
// 3. The Academy gates will be closed at the ringing of the bell in the morning at 08h00. Late comers will not be allowed to enter the campus unless parents have informed the Academy.
// 4. Any change in the Academy timing on account of examinations or other programmes in the Academy will be communicated to parents.
// 5. Students picked up late after school-time may be required to pay additional fee on monthly basis.`,
//     image: '/imageshome/academicyear2.jpg',
//     bgColor: '#FF0000',
//     direction: 'text-left', // text on left, image on right
//   },
// ];

// // Helper to split array into chunks of 3
// const chunkArray = (arr, chunkSize) => {
//   const result = [];
//   for (let i = 0; i < arr.length; i += chunkSize) {
//     result.push(arr.slice(i, i + chunkSize));
//   }
//   return result;
// };

// function GroupExample() {
//   const rows = chunkArray(cardContent, 3); // Split into rows of 3

//   return (
//     <Container fluid className="mt-4 px-4">
//       {rows.map((row, rowIndex) => (
//         <Row key={rowIndex} className="mb-4">
//           {row.map((card, colIndex) => (
//             <Col md={4} key={colIndex}>
//               <Card className="h-100" style={{ backgroundColor: card.bgColor, color: card.textColor }}>
//                 {/* <Card.Img variant="top" src={card.image} /> */}
//                 <Card.Body>
//                   <Card.Title>{card.title}</Card.Title>
//                 </Card.Body>
//                 <Card.Footer>
//                   <Card.Text>{card.text}</Card.Text>
//                 </Card.Footer>
//               </Card>
//             </Col>
//           ))}
//         </Row>
//       ))}
//     </Container>
//   );
// }

// export default GroupExample;

// import Card from 'react-bootstrap/Card';
// import Col from 'react-bootstrap/Col';
// import Row from 'react-bootstrap/Row';
// import Container from 'react-bootstrap/Container';

// const cardContent = [
//   {
//     title: 'ACADEMIC YEAR',
//     text: `The academic year runs from September to June.
// There are three (03) terms in the Primary Section and two (02) in the Secondary / A Level Section:`,
//     image: '/imageshome/academicyear.jpg',
//     bgColor: '#FF00FF',
//     direction: 'image-left', // image on left, text on right
//   },
//   {
//     title: 'PRIMARY',
//     text: `First Term: September – December
// Second Term: January – March
// Third Term: April – June`,
//     image: '/imageshome/academicyear2.jpg',
//     bgColor: '#C0C0C0',
//     direction: 'text-left', // text on left, image on right
//   },
// ];

// function FullWidthCards() {
//   return (
//     <Container fluid className="p-4">
//       {cardContent.map((item, idx) => (
//         <Row key={idx} className="mb-4">
//           {item.direction === 'image-left' ? (
//             <>
//               <Col md={6}>
//                 <Card className="h-100 w-100">
//                   <Card.Img variant="top" src={item.image} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
//                 </Card>
//               </Col>
//               <Col md={6}>
//                 <Card style={{ backgroundColor: item.bgColor, color: 'white' }} className="h-100 w-100">
//                   <Card.Body>
//                     <Card.Title>{item.title}</Card.Title>
//                     <Card.Text>
//                       {item.text.split('\n').map((line, i) => (
//                         <span key={i}>
//                           {line}
//                           <br />
//                         </span>
//                       ))}
//                     </Card.Text>
//                   </Card.Body>
//                 </Card>
//               </Col>
//             </>
//           ) : (
//             <>
//               <Col md={6}>
//                 <Card style={{ backgroundColor: item.bgColor, color: 'white' }} className="h-100 w-100">
//                   <Card.Body>
//                     <Card.Title>{item.title}</Card.Title>
//                     <Card.Text>
//                       {item.text.split('\n').map((line, i) => (
//                         <span key={i}>
//                           {line}
//                           <br />
//                         </span>
//                       ))}
//                     </Card.Text>
//                   </Card.Body>
//                 </Card>
//               </Col>
//               <Col md={6}>
//                 <Card className="h-100 w-100">
//                   <Card.Img variant="top" src={item.image} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
//                 </Card>
//               </Col>
//             </>
//           )}
//         </Row>
//       ))}
//     </Container>
//   );
// }

// export default FullWidthCards;






// import React from 'react';
// import '../../StyleSheets/StyleSheetPages.css';

// function GeneralInformation() {
//   return (
//     <div className="stylesheetpage-container">
//       <div className="stylesheetpage-box">
//         <h2 className="stylesheetpage-title">General Information</h2>

//         <h5 className="stylesheetpage-subtitle">ACADEMIC YEAR</h5>
//         <p className="stylesheetpage-text">
//           The academic year runs from September to June.<br />
//           There are three (03) terms in the Primary Section and two (02) in the Secondary / A Level Section:
//         </p>

//         <h5 className="stylesheetpage-subtitle">PRIMARY</h5>
//         <p className="stylesheetpage-text">
//           First Term: September – December<br />
//           Second Term: January – March<br />
//           Third Term: April – June
//         </p>

//         <h5 className="stylesheetpage-subtitle">SECONDARY</h5>
//         <p className="stylesheetpage-text">
//           First Term: September – January<br />
//           Second Term: February – June
//         </p>

//         <h5 className="stylesheetpage-subtitle">ACADEMY TIMINGS</h5>
//         <p className="stylesheetpage-text">
//           1. The Academy will be open from Monday to Thursday from 08h00 to 15h10 and on Friday from 08h00 till 12h30.
//           Students must report to the Academy by 07h45. <br />
//           2. Timings for Playgroup and FS I are from 07h45 to 12h30 and from 07h45 until 14h00 for FS 2 and Year 1. <br />
//           3. The Academy gates will be closed at the ringing of the bell in the morning at 08h00. Late comers will not be
//           allowed to enter the campus unless parents have informed the Academy. <br />
//           4. Any change in the Academy timing on account of examinations or other programmes in the Academy will be
//           communicated to parents. <br />
//           5. Students picked up late after school-time may be required to pay additional fee on monthly basis.
//         </p>
//       </div>
//     </div>
//   );
// }

// export default GeneralInformation;
